import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import SearchBarContainer from '../../../components/SearchBar/SearchBarContainer';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

const BreadcrumbsDefault = ({
  newOffersCount,
  onSearchClick,
  t,
  tableName,
  isMobile,
}) => {
  const newOffersLabel = (
    newOffersCount ? (
      <div className="main-area__badge main-area__badge--header">
        {`${newOffersCount} ${t('new_offers')}`}
      </div>
    ) : null
  );

  return (
    <div className="main-area__header main-area__header-with_badge">
      { isMobile && <SearchBarContainer onSearchClick={onSearchClick} tableName={tableName} delay={600} /> }

      <div className="details__menu">
        <span>{t(tableName)}</span>
        {newOffersLabel}
      </div>

      { !isMobile && <SearchBarContainer onSearchClick={onSearchClick} tableName={tableName} delay={600} /> }

      <style jsx="true">{`
        .main-area__header {
          display: flex;
          justify-content: space-between;
        }
      `}</style>
    </div>
  );
};

BreadcrumbsDefault.propTypes = {
  t: PropTypes.func.isRequired,
  tableName: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  onSearchClick: PropTypes.func,
  newOffersCount: PropTypes.number,
};

BreadcrumbsDefault.defaultProps = {
  isMobile: true,
}

BreadcrumbsDefault.defaultProps = {
  onSearchClick: null,
  newOffersCount: null,
};

const mapStateToProps = (state) => {
  return {
    isMobile: get(state, ['layout', 'isMobile']),
  };
};

export default compose(connect(mapStateToProps), withScopedTranslations('breadcrumbs.browse'))(BreadcrumbsDefault);
